import { NgModule } from '@angular/core';
import { SharedModule } from '../sharedModule/sharedModule.module';
import { DownloadAppOverlayComponent } from './download-app-overlay.component';

@NgModule({
  imports: [SharedModule],
  declarations: [DownloadAppOverlayComponent],
  exports: [DownloadAppOverlayComponent],
})
export class DownloadAppOverlayModule {}
